export default __webpack_public_path__ + "static/logo.inline-7a1389d2dd3c21305fdf583c9df9c260.png";